import type { NonAdmitReason } from '../services/api/types.gen';

/**
 * Display order and strings for the non-admit reason picker and the intake
 * table cell. Mirrors NON_ADMIT_REASON_LABELS in
 * backend/app/models/enum/intake.py, which owns the Excel export labels;
 * backend/tests/utils/test_non_admit_reasons.py guards the two against drift.
 *
 * Typed as a total Record so adding an enum member on the backend fails
 * `npm run type-check:frontend` here rather than rendering a silent blank.
 */
export const NON_ADMIT_REASON_LABELS: Record<NonAdmitReason, string> = {
  clinical_complexity: 'Clinical Complexity',
  out_of_service_area: 'Out of Service Area',
  staffing: 'Staffing',
  insurance: 'Insurance',
  other: 'Other',
};

export const NON_ADMIT_REASON_OPTIONS: ReadonlyArray<{
  value: NonAdmitReason;
  label: string;
}> = (Object.keys(NON_ADMIT_REASON_LABELS) as NonAdmitReason[]).map(value => ({
  value,
  label: NON_ADMIT_REASON_LABELS[value],
}));

/** The one reason that makes the free-text field mandatory. */
export const NON_ADMIT_REASON_REQUIRING_DETAILS: NonAdmitReason = 'other';

/** Longest free text the backend accepts (IntakeUpdate.non_admit_reason_details). */
export const NON_ADMIT_REASON_DETAILS_MAX_LENGTH = 2000;
